module.exports = __webpack_public_path__ + "img/22.ae2438be.png";